import has from 'lodash/has';
import { isAdminAccess, isManagedResource, isReadOnly } from 'js/lib/ACLUtils';
import { getConnectionOrVendorType } from 'js/lib/ResourceUtils';

export const mapStateToProps = (state, ownProps) => {
  const { cardData } = ownProps;
  const {
    entities: { users, dataSets, vendors },
  } = state;
  const readOnly = isReadOnly(cardData);
  const isManaged = isManagedResource(cardData);
  const adminAccess = isAdminAccess(cardData);
  const isWritingDataset = has(cardData, 'data_set_id') && cardData.data_set_id ? true : false;
  const writingDataSet =
    isWritingDataset && has(dataSets, cardData.data_set_id) ? dataSets[cardData.data_set_id] : null;

  const connectionOrVendorType = getConnectionOrVendorType(
    cardData,
    vendors,
    'sink_type',
    'vendor_id',
  );

  const owner = has(cardData, 'owner') && has(users, cardData.owner) ? users[cardData.owner] : null;

  return {
    readOnly,
    isManaged,
    adminAccess,
    owner,
    connectionOrVendorType,
    isWritingDataset,
    writingDataSet,
  };
};
